import { CommonModule } from '@angular/common';
import { Component, signal, input } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';

@Component({
    selector: 'app-website-config-form-expansion-panel',
    standalone: true,
    imports: [
        MatExpansionModule,
        CommonModule
    ],
    templateUrl: './website-config-form-expansion-panel.component.html',
    styleUrl: './website-config-form-expansion-panel.component.scss'
})
export class WebsiteConfigFormExpansionPanelComponent {
  readonly title = input.required<string | undefined>();
  readonly noMargin = input<boolean>(false);
  readonly firstMarginTop = input<boolean>(false);
  readonly panelOpenState = signal(false);
}
